import Api from "./Api";

const endpoint = "/fibu";
export default {
    get(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + "/buchungskonto", usedParams);
    },
    getSingle(id, params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(endpoint + "/buchungskonto/" + id, usedParams);
    },
    put(id, data) {
        return Api.putData(endpoint + "/buchungskonto/" + id, data);

    },
    post(data) {
        return Api.postData(endpoint + "/buchungskonto", data);

    },
    delete(id) {
        return Api.deleteData(endpoint + "/buchungskonto/" + id);
    }
};
